import { render, staticRenderFns } from "./ProfessionalIndemnity.vue?vue&type=template&id=032495d8&"
import script from "./ProfessionalIndemnity.vue?vue&type=script&lang=js&"
export * from "./ProfessionalIndemnity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports